import { useContext } from "react";
import { Link } from "react-router-dom";
import PokeContext from "../context";

const Pokemon = (props) => {
    const { pokemon } = props;
    const { favorites, updateFavoritePokemon} = useContext(PokeContext);

    const readHeart = '❤️';
	const blackHeart = '🖤';

    const heart = favorites.includes(pokemon.name) ? readHeart : blackHeart;

    const clickHeart = (e) => {
		e.preventDefault();
		updateFavoritePokemon(pokemon.name);
	};

	return (
		<div className="pokemon-card">
			<div className="pokemon-card_container">
				<Link to={`/pokemon/${pokemon.name}`}>
					<img
						src={pokemon.sprites.front_default}
						alt="imagenPokemon"
						className="pokemon-img"
					/>
				</Link>
			</div>

			<div className="card-body">
				<div className="card-top">
					<h3 className="card-title">{pokemon.name}</h3>
					<div className="card-id">#{pokemon.id}</div>
				</div>

				<div className="card-bottom">
					<div className="pokemon-type">
						{pokemon.types.map((type, idx) => {
							return (
								<div
									key={idx}
									className={`pokemon-type-text ${
										idx === 1 ? 'color-a' : 'color-b'
									}`}
								>
									{type.type.name}
								</div>
							);
						})}
					</div>

					<button onClick={clickHeart} className="btn">
						<div className="pokemon-favorite">{heart}</div>
					</button>
				</div>
			</div>
		</div>
	);
};

export default Pokemon;
